
import {mapGetters} from 'vuex';
import Template from 'components/templates/Hamburger.vue';
import Hamburger from 'components/mixins/Hamburger.vue';
// import ButtonBlock from 'components/blocks/Button.vue';

export default {
  block: 'hamburger',
  mixins: [
    Template,
    Hamburger
  ],
  // components: {
  //   ButtonBlock
  // },
  computed: {
    ...mapGetters([
      'isPortrait',
      'mobileMenuOpen',
    ]),
    // white() {
    //   if (this.sections[this.currentSection] == null)
    //     return true;

    //   return (this.sections[this.currentSection].whiteHamburger || this.mobileMenuOpen) ? true : false;
    // },
    // showDemoButton() {
    //   const firstPage = this.getIsPageIndex();
    //   return (this.currentSection == 0 && firstPage);
    // },
  },
  methods: {
    goToDemo() {
      window.location.href = 'https://demo.spotin.com';
    },
    getIsPageIndex() {
      return this.$route.path == "/";
    },
  }
}



// WEBPACK FOOTER //
// ./components/globalBlocks/Hamburger.vue